export default __webpack_public_path__ + "static/media/shopify-logo-icon.3c7e89f1.svg";